module.exports = __webpack_public_path__ + "img/accountBlack.67859ec7.png";